import * as Yup from 'yup';

const getValidationSchemaStep1 = () => {
  const baseSchema = {
    DegreeId: Yup.string().required('DegreeId  is required'),
    DegreeType: Yup.string().required('DegreeType is required'),
    DegreeNameAr: Yup.string().required('DegreeNameAr is required'),
    EntryLevelAr: Yup.string().required('EntryLevelAr is required'),
    CreditHours: Yup.number().required('CreditHours is required'),
    DurationAr: Yup.string().required('DurationAr is required'),
    Languages: Yup.string().required('Languages is required'),
    AboutProgramAr: Yup.string().required('Required'),
    // TotalGraduates: Yup.number().required('TotalGraduates is required'),
    RequiredCourses: Yup.number().required('RequiredCourses is required'),
    ElectiveCourses: Yup.number().required('ElectiveCourses is required'),
    HighlightsAr: Yup.string().required('Required'),
    ForAllOrCadets: Yup.string().required('ForAllOrCadets is required'),
    // Accreditation: Yup.number().required("Accreditation is required"),
    programOutcomes: Yup.array().of(
      Yup.object().shape({
        DegreeId: Yup.string(),
        ProgramOutComeId: Yup.string().required('ProgramOutComeId is required'),
        OutComeAr: Yup.string().required('OutComeAr is required'),
        // OutComeImage: Yup.string(),
      })
    ),
    // ApprovedFees: Yup.number().typeError('يجب إدخال رقم'),

    // KnowledgeInnovation: Yup.number()
    //   .typeError('يجب إدخال رقم')
    //   .min(0, 'القيمة غير صحيحة'),
  };

  return Yup.object().shape(baseSchema);
};
export default getValidationSchemaStep1;
